import { OccConfig } from '@spartacus/core';

export const checkoutAuxOccConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        createAddress: 'users/current/addresses?fields=FULL',
        getShippingPreferences: 'users/current/carts/${cartId}/shipping-preferences?fields=DEFAULT',
        setShippingPreference: 'users/current/carts/${cartId}/shipping-preference',
        setShippingPriority: 'users/current/carts/${cartId}/shipping-priority',
        getSubDeliveryMethods: 'users/current/carts/${cartId}/deliverymodes?fields=DEFAULT',
        getCarriers: 'users/current/carts/${cartId}/carriers?fields=DEFAULT',
      } as any,
    },
  },
};
